import __request__ from "routing/request";
export function getAnomalyDetectorConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.anomaly/detectors/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
